// Single source of truth for supported languages. URL uses ISO 639-1
// codes ('hy' for Armenian); `label` is the display chip in the UI.
export type LanguageCode = 'en' | 'hy' | 'ru' | 'fr' | 'ka' | 'it' | 'zh';

export const LANGUAGES: { code: LanguageCode; label: string }[] = [
  { code: 'en', label: 'EN' },
  { code: 'hy', label: 'AM' },
  { code: 'ru', label: 'RU' },
  { code: 'fr', label: 'FR' },
  { code: 'ka', label: 'GE' },
  { code: 'it', label: 'IT' },
  { code: 'zh', label: 'CH' },
];

export const SUPPORTED_LANGS = LANGUAGES.map((l) => l.code);

export const DEFAULT_LANG: LanguageCode = 'en';

export function isLanguageCode(value: unknown): value is LanguageCode {
  return (
    typeof value === 'string' &&
    (SUPPORTED_LANGS as string[]).includes(value)
  );
}

// Main Aranor site, in the same language. aranortravel.com uses the
// same ISO codes as the passport app (hy for Armenian) but has no
// Georgian site, so 'ka' falls back to the default language.
export function aranorSiteUrl(lang: string): string {
  const code = isLanguageCode(lang) ? lang : DEFAULT_LANG;
  const siteCode = code === 'ka' ? DEFAULT_LANG : code;
  return `https://aranortravel.com/${siteCode}`;
}

// Best-effort browser language → supported code, for the initial
// no-prefix redirect only. Falls back to DEFAULT_LANG.
export function detectBrowserLang(): LanguageCode {
  if (typeof navigator === 'undefined') return DEFAULT_LANG;
  const candidates = [
    ...(navigator.languages ?? []),
    navigator.language,
  ].filter(Boolean);
  for (const c of candidates) {
    const base = c.toLowerCase().split('-')[0];
    if (isLanguageCode(base)) return base;
  }
  return DEFAULT_LANG;
}
